<template>
  <div class="policy-config-container">
    <!-- 顶部统计栏 -->
    <div class="stats-bar">
      <div class="stat-item">
        <i class="el-icon-s-data"></i>
        <div class="stat-content">
          <div class="stat-label">规则总数</div>
          <div class="stat-value">{{ overview.totalRules || 0 }}</div>
        </div>
      </div>
      <div class="stat-item success">
        <i class="el-icon-circle-check"></i>
        <div class="stat-content">
          <div class="stat-label">已启用</div>
          <div class="stat-value">{{ overview.enabledRules || 0 }}</div>
        </div>
      </div>
      <div class="stat-item warning">
        <i class="el-icon-warning-outline"></i>
        <div class="stat-content">
          <div class="stat-label">已禁用</div>
          <div class="stat-value">{{ overview.disabledRules || 0 }}</div>
        </div>
      </div>
      <div class="stat-item info">
        <i class="el-icon-time"></i>
        <div class="stat-content">
          <div class="stat-label">最后发布</div>
          <div class="stat-value">{{ overview.lastPublishTime || '-' }}</div>
        </div>
      </div>
      <div class="publish-btn">
        <el-button type="primary" icon="el-icon-upload" @click="handlePublish" :loading="publishLoading">
          发布配置
        </el-button>
      </div>
    </div>

    <!-- 评分阈值配置 -->
    <el-card class="threshold-card" shadow="hover">
      <div slot="header" class="card-header">
        <i class="el-icon-s-data"></i>
        <span>评分阈值配置</span>
        <el-button size="small" type="primary" plain @click="handleEditThreshold">编辑</el-button>
      </div>
      <div class="threshold-list">
        <div v-for="(item, index) in thresholdList" :key="item ? item.id || index : index" class="threshold-item" v-if="item">
          <div class="level-badge" :style="{ background: item.color }">{{ item.levelName }}</div>
          <div class="score-range">分值区间: {{ item.minScore }} - {{ item.maxScore }}</div>
          <div class="action-tag">
            <el-tag size="small">{{ item.action }}</el-tag>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 规则列表 -->
    <el-card class="rules-card" shadow="hover">
      <div slot="header" class="card-header">
        <i class="el-icon-s-operation"></i>
        <span>风控规则配置</span>
      </div>
      <el-table :data="ruleList" border stripe>
        <el-table-column prop="ruleName" label="规则名称" width="180"></el-table-column>
        <el-table-column prop="ruleDesc" label="描述" min-width="200"></el-table-column>
        <el-table-column prop="category" label="分类" width="120" align="center"></el-table-column>
        <el-table-column prop="riskScore" label="风险分值" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getScoreTagType(scope.row.riskScore)" size="small">
              {{ scope.row.riskScore }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleToggleStatus(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEditRule(scope.row)">
              <i class="el-icon-edit"></i> 编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑规则弹窗 -->
    <el-dialog title="编辑规则" :visible.sync="editRuleVisible" width="600px">
      <el-form :model="editRuleForm" label-width="100px">
        <el-form-item label="规则名称">
          <el-input v-model="editRuleForm.ruleName" disabled></el-input>
        </el-form-item>
        <el-form-item label="风险分值">
          <el-input-number v-model="editRuleForm.riskScore" :min="0" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="规则参数">
          <el-input type="textarea" v-model="editRuleForm.configParams" :rows="4" placeholder="JSON格式"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editRuleVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditRule">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑阈值弹窗 -->
    <el-dialog title="编辑评分阈值" :visible.sync="editThresholdVisible" width="700px">
      <el-table :data="editThresholdList" border>
        <el-table-column prop="levelName" label="风险等级" width="120"></el-table-column>
        <el-table-column label="最小分值" width="120">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.minScore" :min="0" size="small" :disabled="scope.row.id !== 'low'"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="最大分值" width="120">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.maxScore" :min="0" :max="100" size="small"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="处理动作" width="180">
          <template slot-scope="scope">
            <el-select v-model="scope.row.action" size="small">
              <el-option label="PASS（通过）" value="PASS"></el-option>
              <el-option label="LOG（记录）" value="LOG"></el-option>
              <el-option label="3DS（强认证）" value="3DS"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="editThresholdVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditThreshold">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPolicyConfigOverview,
  queryRuleList,
  updateRule,
  toggleRuleStatus,
  getScoreThreshold,
  updateScoreThreshold,
  publishPolicyConfig
} from '@/api/risk/riskApi'

export default {
  name: 'policyConfig',

  data () {
    return {
      overview: {},
      thresholdList: [],
      ruleList: [],
      editRuleVisible: false,
      editRuleForm: {},
      editThresholdVisible: false,
      editThresholdList: [],
      publishLoading: false
    }
  },

  methods: {
    // 获取概览数据
    getOverview () {
      getPolicyConfigOverview().then((res) => {
        console.log('概览数据返回:', res)
        const { data, code } = res
        if (code === 0) {
          this.overview = data || {}
          console.log('概览数据:', this.overview)
        }
      })
    },

    // 获取阈值配置
    getThreshold () {
      getScoreThreshold().then((res) => {
        console.log('阈值数据返回:', res)
        const { data, code } = res
        if (code === 0) {
          // 将对象转换为数组格式
          if (data && typeof data === 'object') {
            this.thresholdList = [
              {
                id: 'low',
                levelName: '低风险',
                minScore: 0,
                maxScore: data.lowThreshold || 40,
                action: data.lowAction || 'PASS',
                color: '#67c23a'
              },
              {
                id: 'medium',
                levelName: '中风险',
                minScore: data.lowThreshold || 40,
                maxScore: data.mediumThreshold || 80,
                action: data.mediumAction || 'LOG',
                color: '#e6a23c'
              },
              {
                id: 'high',
                levelName: '高风险',
                minScore: data.mediumThreshold || 80,
                maxScore: 100,
                action: data.highAction || '3DS',
                color: '#f56c6c'
              }
            ]
          } else {
            this.thresholdList = []
          }
          console.log('阈值列表:', this.thresholdList)
        }
      })
    },

    // 获取规则列表
    getRules () {
      queryRuleList().then((res) => {
        console.log('规则列表返回:', res)
        const { data, code } = res
        if (code === 0) {
          // 填充默认数据到表格
          this.ruleList = (data || []).map(item => ({
            ruleCode: item.ruleCode,
            ruleName: item.ruleName,
            ruleDesc: item.ruleDesc || '暂无描述',
            category: item.category || '风控检测',
            riskScore: item.riskScore !== null ? item.riskScore : 50,
            status: item.status !== null ? item.status : 1,
            configParams: item.configParams || '{}',
            sortOrder: item.sortOrder
          }))
          console.log('规则列表:', this.ruleList)
        }
      })
    },

    // 切换规则状态
    handleToggleStatus (row) {
      toggleRuleStatus(row.ruleCode).then(({ code }) => {
        if (code === 0) {
          this.$message.success('状态已更新')
          this.getOverview()
        }
      })
    },

    // 编辑规则
    handleEditRule (row) {
      this.editRuleForm = { ...row }
      this.editRuleVisible = true
    },

    // 提交编辑规则
    submitEditRule () {
      const data = {
        ruleCode: this.editRuleForm.ruleCode,
        riskScore: this.editRuleForm.riskScore,
        configParams: this.editRuleForm.configParams
      }
      updateRule(data).then(({ code }) => {
        if (code === 0) {
          this.$message.success('更新成功')
          this.editRuleVisible = false
          this.getRules()
        }
      })
    },

    // 编辑阈值
    handleEditThreshold () {
      this.editThresholdList = JSON.parse(JSON.stringify(this.thresholdList))
      this.editThresholdVisible = true
    },

    // 提交编辑阈值
    submitEditThreshold () {
      // 重新计算分值区间，确保连续性
      this.editThresholdList[0].minScore = 0
      this.editThresholdList[1].minScore = this.editThresholdList[0].maxScore
      this.editThresholdList[2].minScore = this.editThresholdList[1].maxScore

      // 将数组格式转换回对象格式
      const data = {
        lowThreshold: this.editThresholdList[0].maxScore,
        mediumThreshold: this.editThresholdList[1].maxScore,
        lowAction: this.editThresholdList[0].action,
        mediumAction: this.editThresholdList[1].action,
        highAction: this.editThresholdList[2].action
      }
      updateScoreThreshold(data).then(({ code }) => {
        if (code === 0) {
          this.$message.success('更新成功')
          this.editThresholdVisible = false
          this.getThreshold()
        }
      })
    },

    // 发布配置
    handlePublish () {
      this.$confirm('确认发布当前配置？发布后将立即生效。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.publishLoading = true
        publishPolicyConfig().then(({ code }) => {
          if (code === 0) {
            this.$message.success('发布成功')
            this.getOverview()
          }
          this.publishLoading = false
        }).catch(() => {
          this.publishLoading = false
        })
      }).catch(() => {})
    },

    getScoreTagType (score) {
      if (score >= 60) return 'danger'
      if (score >= 30) return 'warning'
      return 'info'
    }
  },

  created () {
    this.getOverview()
    this.getThreshold()
    this.getRules()
  }
}
</script>

<style lang="scss" scoped>
.policy-config-container {
  padding: 20px;
  background: #fff;
  min-height: 100%;
}

.stats-bar {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  align-items: center;

  .stat-item {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;

    i {
      font-size: 32px;
      color: #409eff;
    }

    &.success i { color: #67c23a; }
    &.warning i { color: #e6a23c; }
    &.info i { color: #909399; }

    .stat-content {
      .stat-label {
        font-size: 14px;
        color: #909399;
        margin-bottom: 4px;
      }
      .stat-value {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .publish-btn {
    flex-shrink: 0;
  }
}

.threshold-card, .rules-card {
  margin-bottom: 20px;

  .card-header {
    display: flex;
    align-items: center;
    gap: 8px;

    i { font-size: 18px; color: #409eff; }

    span { flex: 1; font-weight: 600; }
  }
}

.threshold-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  .threshold-item {
    padding: 16px;
    border-radius: 8px;
    background: #f5f7fa;
    text-align: center;

    .level-badge {
      display: inline-block;
      padding: 6px 16px;
      border-radius: 4px;
      color: #fff;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .score-range {
      font-size: 14px;
      color: #606266;
      margin-bottom: 8px;
    }

    .action-tag {
      font-size: 12px;
    }
  }
}
</style>
